import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';

export const InlineFlex = styled(Div)`
  display: inline-flex;
  vertical-align: middle;
`;
